export type Data = {
	order: number;
	date: Date;
};
export const DATA: Data[] = [
	{
		order: 0,
		date: new Date('1981-05-26T21:33:43.612Z'),
	},
	{
		order: 1,
		date: new Date('1971-04-25T19:44:17.014Z'),
	},
	{
		order: 2,
		date: new Date('1986-07-10T11:39:29.539Z'),
	},
	{
		order: 3,
		date: new Date('1976-02-02T10:00:36.346Z'),
	},
	{
		order: 4,
		date: new Date('1998-07-07T12:50:36.016Z'),
	},
	{
		order: 5,
		date: new Date('1994-09-05T05:10:44.078Z'),
	},
	{
		order: 6,
		date: new Date('1986-05-23T13:05:01.874Z'),
	},
	{
		order: 7,
		date: new Date('1975-06-29T21:51:29.359Z'),
	},
	{
		order: 8,
		date: new Date('1974-05-15T23:47:02.499Z'),
	},
	{
		order: 9,
		date: new Date('1990-05-27T10:13:19.641Z'),
	},
	{
		order: 10,
		date: new Date('1993-10-20T03:54:08.739Z'),
	},
	{
		order: 11,
		date: new Date('2000-02-25T11:55:43.705Z'),
	},
	{
		order: 12,
		date: new Date('1988-08-27T09:59:12.251Z'),
	},
	{
		order: 13,
		date: new Date('1980-10-24T10:41:24.897Z'),
	},
	{
		order: 14,
		date: new Date('1995-01-25T12:31:27.983Z'),
	},
	{
		order: 15,
		date: new Date('1995-04-15T02:00:39.048Z'),
	},
	{
		order: 16,
		date: new Date('1994-03-15T19:13:04.564Z'),
	},
	{
		order: 17,
		date: new Date('1999-03-02T16:53:04.418Z'),
	},
	{
		order: 18,
		date: new Date('1982-08-23T18:37:38.014Z'),
	},
	{
		order: 19,
		date: new Date('1995-06-19T12:39:56.321Z'),
	},
	{
		order: 20,
		date: new Date('1994-09-23T15:03:35.746Z'),
	},
	{
		order: 21,
		date: new Date('1990-04-15T23:38:02.147Z'),
	},
	{
		order: 22,
		date: new Date('1983-08-01T10:36:44.006Z'),
	},
	{
		order: 23,
		date: new Date('1986-06-28T21:27:04.588Z'),
	},
	{
		order: 24,
		date: new Date('1986-08-14T19:34:40.904Z'),
	},
	{
		order: 25,
		date: new Date('1998-07-14T15:52:29.010Z'),
	},
	{
		order: 26,
		date: new Date('1985-02-15T18:56:32.344Z'),
	},
	{
		order: 27,
		date: new Date('1989-09-06T10:49:30.896Z'),
	},
	{
		order: 28,
		date: new Date('1994-09-05T14:21:37.211Z'),
	},
	{
		order: 29,
		date: new Date('1995-12-15T23:12:14.411Z'),
	},
	{
		order: 30,
		date: new Date('1986-08-14T19:34:40.904Z'),
	},
	{
		order: 31,
		date: new Date('1985-02-15T18:56:32.344Z'),
	},
	{
		order: 32,
		date: new Date('1989-09-06T10:49:30.896Z'),
	},
	{
		order: 33,
		date: new Date('1994-09-05T14:21:37.211Z'),
	},
	{
		order: 34,
		date: new Date('1995-12-15T23:12:14.411Z'),
	},
	{
		order: 35,
		date: new Date('1986-08-14T19:34:40.904Z'),
	},
	{
		order: 36,
		date: new Date('1985-02-15T18:56:32.344Z'),
	},
	{
		order: 37,
		date: new Date('1989-09-06T10:49:30.896Z'),
	},
	{
		order: 38,
		date: new Date('1994-09-05T14:21:37.211Z'),
	},
	{
		order: 39,
		date: new Date('1995-12-15T23:12:14.411Z'),
	},
	{
		order: 40,
		date: new Date('1986-08-14T19:34:40.904Z'),
	},
	{
		order: 41,
		date: new Date('1985-02-15T18:56:32.344Z'),
	},
	{
		order: 42,
		date: new Date('1989-09-06T10:49:30.896Z'),
	},
	{
		order: 43,
		date: new Date('1994-09-05T14:21:37.211Z'),
	},
	{
		order: 44,
		date: new Date('1995-12-15T23:12:14.411Z'),
	},
	{
		order: 45,
		date: new Date('1986-08-14T19:34:40.904Z'),
	},
	{
		order: 46,
		date: new Date('1985-02-15T18:56:32.344Z'),
	},
	{
		order: 47,
		date: new Date('1989-09-06T10:49:30.896Z'),
	},
	{
		order: 48,
		date: new Date('1994-09-05T14:21:37.211Z'),
	},
	{
		order: 49,
		date: new Date('1995-12-15T23:12:14.411Z'),
	},
	{
		order: 50,
		date: new Date('1986-08-14T19:34:40.904Z'),
	},
	{
		order: 51,
		date: new Date('1985-02-15T18:56:32.344Z'),
	},
	{
		order: 52,
		date: new Date('1989-09-06T10:49:30.896Z'),
	},
	{
		order: 53,
		date: new Date('1994-09-05T14:21:37.211Z'),
	},
	{
		order: 54,
		date: new Date('1995-12-15T23:12:14.411Z'),
	},
	{
		order: 55,
		date: new Date('1986-08-14T19:34:40.904Z'),
	},
	{
		order: 56,
		date: new Date('1985-02-15T18:56:32.344Z'),
	},
	{
		order: 57,
		date: new Date('1989-09-06T10:49:30.896Z'),
	},
	{
		order: 58,
		date: new Date('1994-09-05T14:21:37.211Z'),
	},
	{
		order: 59,
		date: new Date('1995-12-15T23:12:14.411Z'),
	},
	{
		order: 60,
		date: new Date('1986-08-14T19:34:40.904Z'),
	},
	{
		order: 61,
		date: new Date('1985-02-15T18:56:32.344Z'),
	},
	{
		order: 62,
		date: new Date('1989-09-06T10:49:30.896Z'),
	},
	{
		order: 63,
		date: new Date('1994-09-05T14:21:37.211Z'),
	},
	{
		order: 64,
		date: new Date('1995-12-15T23:12:14.411Z'),
	},
	{
		order: 65,
		date: new Date('1986-08-14T19:34:40.904Z'),
	},
	{
		order: 66,
		date: new Date('1985-02-15T18:56:32.344Z'),
	},
	{
		order: 67,
		date: new Date('1989-09-06T10:49:30.896Z'),
	},
	{
		order: 68,
		date: new Date('1994-09-05T14:21:37.211Z'),
	},
	{
		order: 69,
		date: new Date('1995-12-15T23:12:14.411Z'),
	},
	{
		order: 70,
		date: new Date('1986-08-14T19:34:40.904Z'),
	},
	{
		order: 71,
		date: new Date('1985-02-15T18:56:32.344Z'),
	},
	{
		order: 72,
		date: new Date('1989-09-06T10:49:30.896Z'),
	},
	{
		order: 73,
		date: new Date('1994-09-05T14:21:37.211Z'),
	},
	{
		order: 74,
		date: new Date('1995-12-15T23:12:14.411Z'),
	},
	{
		order: 75,
		date: new Date('1986-08-14T19:34:40.904Z'),
	},
	{
		order: 76,
		date: new Date('1985-02-15T18:56:32.344Z'),
	},
	{
		order: 77,
		date: new Date('1989-09-06T10:49:30.896Z'),
	},
	{
		order: 78,
		date: new Date('1994-09-05T14:21:37.211Z'),
	},
	{
		order: 79,
		date: new Date('1995-12-15T23:12:14.411Z'),
	},
	{
		order: 80,
		date: new Date('1986-08-14T19:34:40.904Z'),
	},
	{
		order: 81,
		date: new Date('1985-02-15T18:56:32.344Z'),
	},
	{
		order: 82,
		date: new Date('1989-09-06T10:49:30.896Z'),
	},
	{
		order: 83,
		date: new Date('1994-09-05T14:21:37.211Z'),
	},
	{
		order: 84,
		date: new Date('1995-12-15T23:12:14.411Z'),
	},
	{
		order: 85,
		date: new Date('1986-08-14T19:34:40.904Z'),
	},
	{
		order: 86,
		date: new Date('1985-02-15T18:56:32.344Z'),
	},
	{
		order: 87,
		date: new Date('1989-09-06T10:49:30.896Z'),
	},
	{
		order: 88,
		date: new Date('1994-09-05T14:21:37.211Z'),
	},
	{
		order: 89,
		date: new Date('1995-12-15T23:12:14.411Z'),
	},
	{
		order: 90,
		date: new Date('1986-08-14T19:34:40.904Z'),
	},
	{
		order: 91,
		date: new Date('1985-02-15T18:56:32.344Z'),
	},
	{
		order: 92,
		date: new Date('1989-09-06T10:49:30.896Z'),
	},
	{
		order: 93,
		date: new Date('1994-09-05T14:21:37.211Z'),
	},
	{
		order: 94,
		date: new Date('1995-12-15T23:12:14.411Z'),
	},
	{
		order: 95,
		date: new Date('1986-08-14T19:34:40.904Z'),
	},
	{
		order: 96,
		date: new Date('1985-02-15T18:56:32.344Z'),
	},
	{
		order: 97,
		date: new Date('1989-09-06T10:49:30.896Z'),
	},
	{
		order: 98,
		date: new Date('1994-09-05T14:21:37.211Z'),
	},
	{
		order: 99,
		date: new Date('1995-12-15T23:12:14.411Z'),
	},
];
